<template>
    <div class="opsd-form-container">
        <be-hero-button-group
            v-if="graphTypeData.options"
            :button-options="graphTypeData.options"
            :selected="graphTypeData.selected"
            @selected="onGraphTypeSelected"
        />

        <div class="profile-picker-row">
            <label>Online profiles for display</label>
            <div class="deq-input-div" @click="onShowProfilePicker">
                <span class="deq-placeholder" v-if="!selectedOnlineProfiles.length">Support profiles</span>
                <SlottedTag v-for="profile in selectedOnlineProfiles" :key="profile.id" @close="unselectProfile(profile)">
                    <i :class="getProfileIcon(profile.type)"></i>{{ profile.name }}
                </SlottedTag>
            </div>
        </div>
    </div>
</template>

<script>

import BeHeroButtonGroup from "@/components/buttons/be-hero-button-group/BeHeroButonGroup.vue";
import { graphOptions } from "./bhbg-types";
import {showDialogComponent} from "@/app/framework/dialogs/DialogUtilities";
import ProfilePickerDialog from "@/app/framework/dialogs/ProfilePickerDialog.vue";
import SlottedTag from "@/components/tags/SlottedTag.vue";
import {getProfileIcon} from "@/setup/profiles/ProfileUtils";

export default {
    components: {
        SlottedTag,
        BeHeroButtonGroup,
    },
    props: {
        initialGraphType: {
            type: String,
            default: null
        },
        initialProfiles: {
            type: Array,
            default: () => []
        }
    },

    data() {
        return {
            valid: true,
            graphTypeData: {
                options: null,
                selected: null
            },
            selectedOnlineProfiles: [],
        }
    },
    mounted() {
        this.graphTypeData.options = graphOptions;

        if (this.initialGraphType) {
            this.graphTypeData.selected = this.initialGraphType;
        }
        if (this.initialProfiles && this.initialProfiles.length) {
            this.selectedOnlineProfiles = this.initialProfiles.slice();
        }
    },

    watch: {
        initialGraphType(newVal) {
            this.graphTypeData.selected = newVal;
        },
        initialProfiles(newVal) {
            this.selectedOnlineProfiles = (newVal || []).slice();
        }
    },

    methods: {
        getProfileIcon,

        onGraphTypeSelected(updatedGraphType) {
            this.graphTypeData.selected = updatedGraphType;
            this.emitData();
        },

        onShowProfilePicker() {
            const dialog = showDialogComponent(ProfilePickerDialog, {
                previousSelected: this.selectedOnlineProfiles.map(p => p.id),
                allowNegation: false
            });

            dialog.$on('selected', (updatedProfiles) => {
                this.selectedOnlineProfiles = updatedProfiles || [];
                this.emitData();
            });
        },

        unselectProfile(profile) {
            this.selectedOnlineProfiles = this.selectedOnlineProfiles.filter(p => p.id !== profile.id);
            this.emitData();
        },

        emitData() {
            const formData = {
                graphType: this.graphTypeData.selected,
                profiles: this.selectedOnlineProfiles
            };

            this.$emit('form-updated', formData);
        }
    }
}
</script>

<style scoped>
.opsd-form-container {
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.deq-input-div {
    padding: 10px;
    cursor: pointer;
}
</style>